module.exports = __webpack_public_path__ + "img/logo2.cd2362e5.png";